<template>
  <div id="commonDoubleChooseModal">
    <div class="choose__bg" @click="closeModal"></div>
    <div class="choose__container" :class="[theme]">
      <div class="choose__header">
        <p class="header__title">{{ title }}</p>
        <i class="header__close" @click="closeModal" />
      </div>
      <p v-if="content !== ''" class="choose__content" v-html="content"></p>
      <div class="choose__items">
        <p
          class="choose__item"
          :class="{ disabled: item.disabled === true }"
          v-for="(item, index) in items"
          :key="index"
          @click="clickItem(item)"
        >
          {{ item.name }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonTripleChooseModal',
  props: {
    theme: { type: String, default: '' },
    title: { type: String, default: '' },
    content: { type: String, default: '' },
    items: { type: Array, default: () => [] }
  },
  mounted() {
    const html = document.querySelector('html')
    html.style.overflow = 'hidden'
  },
  destroyed() {
    const html = document.querySelector('html')
    html.style.removeProperty('overflow')
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
    },
    clickItem(val) {
      if (val.disabled === true) {
        this.$emit('open-alert', val.value)
        return false
      }
      this.$emit('click-item', val.value)
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/_index.scss';
#commonDoubleChooseModal {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  .choose__bg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    position: relative;
    z-index: 1;
  }
  .choose__container {
    width: 448px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 12px;
    padding: 0 24px;
    background-color: #ffffff;
    z-index: 2;
    .choose__header {
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .header__title {
        font-size: 20px;
        font-weight: $medium;
      }
      .header__close {
        display: inline-block;
        width: 24px;
        height: 24px;
        background-image: url(https://dcse8twossp9.cloudfront.net/static/img/icon/close-black-24-px.svg);
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
      }
    }
    .choose__content {
      font-size: 15px;
      color: #555555;
      word-break: keep-all;
    }
    .choose__items {
      padding-top: 24px;
      padding-bottom: 24px;
      display: grid;
      grid-template-columns: 33% 33% 33%;
      justify-content: center;
      align-items: center;
      .choose__item {
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 12px;
        border: 1px solid #000000;
        cursor: pointer;
        margin-bottom: 8px;
        margin-left: 8px;
      }
      .choose__item:first-child {
        margin-left: 0;
      }
    }
    &.black {
      background-color: #232323;
      .choose__header {
        .header__title {
          color: #ffffff;
        }
        .header__close {
          background-image: url(https://dcse8twossp9.cloudfront.net/static/img/icon/close-white.svg);
        }
      }
      .choose__content {
        color: #b9b9b9;
      }
      .choose__items {
        .choose__item {
          border-color: #414141;
          color: #ffffff;
          &.disabled {
            color: #414141;
            cursor: default;
          }
        }
      }
    }
  }
}
@media all and (max-width: 768px) {
  #commonDoubleChooseModal {
    .choose__container {
      width: 100%;
      top: unset;
      left: 0;
      bottom: 0;
      transform: unset;
      border-radius: 0;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      background-color: #ffffff;
      z-index: 2;
      .choose__items {
        padding-bottom: calc(40px + constant(safe-area-inset-bottom));
        padding-bottom: calc(40px + env(safe-area-inset-bottom));
      }
    }
  }
}
</style>
